import { render } from "./CarouselDraggable.vue?vue&type=template&id=f7c30a22&scoped=true"
import script from "./CarouselDraggable.vue?vue&type=script&lang=js"
export * from "./CarouselDraggable.vue?vue&type=script&lang=js"

import "./CarouselDraggable.vue?vue&type=style&index=0&id=f7c30a22&lang=postcss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7c30a22"]])

export default __exports__